// Local translations
export const T = {
  en_GB: {
    derivedStatuses: "Derived Statuses",
    derivedStatusesDescription:
      "Named classifications computed from the entered financial data. On every save, the values of the selected source fields are summed and the matching threshold determines the status (e.g. Segment: Affluent). A status that includes accounts also updates while the flow is open, as account values change.",
    noStatuses: 'No derived statuses configured. Click "Add Status" to create one.',
    addStatus: "Add Status",
    editStatus: "Edit Status",
    dialogDescription:
      "Name the status and choose the source fields and thresholds that resolve it.",
    label: "Label",
    labelPlaceholder: "e.g., Segment",
    sourceFields: "Source Fields",
    sourceFieldsPerson: "Source fields (persons)",
    sourceFieldsCompany: "Source fields (companies)",
    sourceFieldsGroup: "Source fields (groups)",
    sourceFieldsHint:
      "The values of the selected fields are summed to resolve the status. Ticking Synced account values also adds the client's account balances, converted to the flow currency.",
    noFieldsForType: "No fields configured for this client type.",
    accountsGroup: "Accounts",
    accounts: "Synced account values",
    plusAccounts: "+ accounts",
    thresholds: "Thresholds",
    thresholdsHint:
      "The highest threshold with sum ≥ minimum wins. At least one threshold is required.",
    thresholdValue: "Status value",
    thresholdValuePlaceholder: "e.g., affluent",
    thresholdMin: "Minimum",
    addThreshold: "Add Threshold",
    income: "Income",
    assets: "Assets",
    liabilities: "Liabilities",
    commitments: "Commitments",
    personFields: "persons",
    companyFields: "companies",
    groupFields: "groups",
    fields: "field(s)",
    actions: "Actions",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    deleteStatus: "Delete Status",
    deleteDescription:
      "Are you sure you want to delete this derived status? It will no longer be computed on future saves.",
    error: "Error",
    saved: "Saved",
    failedToSave: "Failed to save",
    labelRequired: "Label is required",
    thresholdRequired: "At least one threshold with a value is required",
  },
  nb_NO: {
    derivedStatuses: "Avledede statuser",
    derivedStatusesDescription:
      "Navngitte klassifiseringer beregnet fra de registrerte økonomidataene. Ved hver lagring summeres verdiene i de valgte kildefeltene, og terskelen som samsvarer bestemmer statusen (f.eks. Segment: Affluent). En status som inkluderer kontoer oppdateres også mens flyten er åpen, når kontoverdiene endres.",
    noStatuses: 'Ingen avledede statuser konfigurert. Klikk "Legg til status" for å opprette en.',
    addStatus: "Legg til status",
    editStatus: "Rediger status",
    dialogDescription: "Gi statusen et navn og velg kildefeltene og tersklene som avgjør den.",
    label: "Etikett",
    labelPlaceholder: "f.eks., Segment",
    sourceFields: "Kildefelter",
    sourceFieldsPerson: "Kildefelter (personer)",
    sourceFieldsCompany: "Kildefelter (selskaper)",
    sourceFieldsGroup: "Kildefelter (grupper)",
    sourceFieldsHint:
      "Verdiene i de valgte feltene summeres for å bestemme statusen. Med Synkroniserte kontoverdier legges også klientens kontosaldoer til, omregnet til flytens valuta.",
    noFieldsForType: "Ingen felt konfigurert for denne klienttypen.",
    accountsGroup: "Kontoer",
    accounts: "Synkroniserte kontoverdier",
    plusAccounts: "+ kontoer",
    thresholds: "Terskler",
    thresholdsHint:
      "Den høyeste terskelen med sum ≥ minimum vinner. Minst én terskel er obligatorisk.",
    thresholdValue: "Statusverdi",
    thresholdValuePlaceholder: "f.eks., affluent",
    thresholdMin: "Minimum",
    addThreshold: "Legg til terskel",
    income: "Inntekt",
    assets: "Eiendeler",
    liabilities: "Gjeld",
    commitments: "Forpliktelser",
    personFields: "personer",
    companyFields: "selskaper",
    groupFields: "grupper",
    fields: "felt",
    actions: "Handlinger",
    save: "Lagre",
    cancel: "Avbryt",
    delete: "Slett",
    deleteStatus: "Slett status",
    deleteDescription:
      "Er du sikker på at du vil slette denne avledede statusen? Den vil ikke lenger beregnes ved fremtidige lagringer.",
    error: "Feil",
    saved: "Lagret",
    failedToSave: "Kunne ikke lagre",
    labelRequired: "Etikett er obligatorisk",
    thresholdRequired: "Minst én terskel med verdi er obligatorisk",
  },
} as const;
